/* Anguissa Fit Studio — Shadow DOM isolated size chart widget.
   Boots into #anguissa-fit-host; all markup is embedded here (no <template>
   needed, so it survives Shopify Custom Liquid / rich-text sanitizers).
   Self-contained: theme CSS cannot cross the Shadow DOM boundary. */
(function () {
  var WIDGET_HTML = `<style>
    :host {
      all: initial;
      display: block;
      width: 100%;
      box-sizing: border-box;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
      font-size: 16px;
      line-height: 1.5;
      letter-spacing: normal;
      text-transform: none;
      font-style: normal;
      font-weight: 400;
      color: #14110d;
      -webkit-text-size-adjust: 100%;
      text-rendering: optimizeLegibility;
    }
  </style>
  <style>
    @import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,300;9..144,400;9..144,500;9..144,600;9..144,700&display=swap');
    .ms-sg {
      --ms-surface: #faf8f5;
      --ms-surface-2: #f3efe9;
      --ms-ink: #14110d;
      --ms-ink-2: #3a352e;
      --ms-muted: #8a8175;
      --ms-line: #ece6dd;
      --ms-line-2: #ddd5c8;
      --ms-accent: #a8763f;
      --ms-accent-deep: #8a5f2f;
      --ms-accent-soft: #f4ecdf;
      --ms-radius: 8px;
      --ms-radius-lg: 16px;
      --ms-radius-xl: 22px;
      --ms-shadow: 0 1px 2px rgba(80,60,30,0.04), 0 8px 28px rgba(80,60,30,0.06);
      --ms-shadow-lg: 0 4px 12px rgba(80,60,30,0.06), 0 24px 60px rgba(80,60,30,0.12);
      --ms-ease: cubic-bezier(.22,.61,.36,1);
      max-width: 760px;
      margin: 0 auto;
      padding: 16px 16px 32px;
      color: var(--ms-ink);
      line-height: 1.5;
      font-size: 16px;
      overflow-x: hidden;
      container-type: inline-size;
      container-name: msg;
      -webkit-font-smoothing: antialiased;
    }
    .ms-sg, .ms-sg *, .ms-sg *::before, .ms-sg *::after { box-sizing: border-box; }
    .ms-sg button { -webkit-appearance: none; appearance: none; margin: 0; font-family: inherit; line-height: 1; cursor: pointer; }
    .ms-sg input[type="number"]::-webkit-outer-spin-button,
    .ms-sg input[type="number"]::-webkit-inner-spin-button,
    .ms-sg .ms-input::-webkit-outer-spin-button,
    .ms-sg .ms-input::-webkit-inner-spin-button {
      -webkit-appearance: none !important; appearance: none !important; margin: 0 !important; display: none !important;
    }
    .ms-sg input[type="number"],
    .ms-sg .ms-input[type="number"] { -moz-appearance: textfield !important; appearance: textfield !important; }
    @keyframes msFade { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
    @keyframes msPop { 0% { opacity: 0; transform: scale(.82); } 60% { transform: scale(1.04); } 100% { opacity: 1; transform: scale(1); } }
    .ms-head { text-align: center; margin-bottom: 16px; }
    .ms-head .ms-kicker {
      font-size: 10.5px; font-weight: 600; letter-spacing: 0.28em; text-transform: uppercase;
      color: var(--ms-accent); margin: 0 0 7px;
    }
    .ms-head h1 {
      font-family: 'Fraunces', 'Times New Roman', serif; font-weight: 300;
      font-size: clamp(26px, 6cqw, 36px); line-height: 1.05; letter-spacing: -0.015em; margin: 0;
    }
    .ms-head h1 em { font-style: italic; color: var(--ms-accent); }
    .ms-toggles { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 12px; }
    .ms-segment {
      display: grid !important; grid-auto-flow: column !important; grid-auto-columns: 1fr !important;
      align-items: center !important; border: 1px solid var(--ms-line-2); border-radius: 11px;
      background: #fff; padding: 4px !important; gap: 3px; flex: 1 1 auto;
      box-shadow: inset 0 1px 2px rgba(80,60,30,0.02);
    }
    .ms-segment.ms-seg-unit { flex: 0 0 auto; }
    .ms-segment button {
      position: relative; width: 100% !important; min-width: 0 !important; border: 0 !important;
      background: transparent !important; padding: 9px 13px !important; font-size: 12px !important;
      letter-spacing: 0.05em !important; text-transform: uppercase !important; font-weight: 600 !important;
      color: var(--ms-muted) !important; border-radius: 8px !important; line-height: 1 !important;
      min-height: 38px !important; white-space: nowrap !important; box-shadow: none !important;
      transition: color .25s var(--ms-ease);
    }
    .ms-segment button.is-active {
      color: #fff !important;
      background: var(--ms-ink) !important;
      box-shadow: 0 1px 4px rgba(20,17,13,0.16) !important;
      animation: msFade .2s var(--ms-ease);
    }
    .ms-card {
      position: relative; background: #fff; border: 1px solid var(--ms-line);
      border-radius: var(--ms-radius-xl); box-shadow: var(--ms-shadow);
      overflow: hidden;
    }
    .ms-hero {
      position: relative; padding: 22px 22px 20px;
      background:
        radial-gradient(120% 140% at 100% 0%, rgba(168,118,63,0.10) 0%, rgba(168,118,63,0) 55%),
        linear-gradient(165deg, #fffdfa 0%, #f6efe4 100%);
      border-bottom: 1px solid var(--ms-line);
    }
    .ms-hero-empty { display: flex; align-items: center; gap: 14px; }
    .ms-hero-empty .ms-hero-mark {
      width: 46px; height: 46px; border-radius: 14px; flex-shrink: 0;
      background: #fff; border: 1px solid var(--ms-line-2);
      display: flex; align-items: center; justify-content: center; color: var(--ms-accent);
      box-shadow: var(--ms-shadow);
    }
    .ms-hero-empty .ms-hero-mark svg { width: 24px; height: 24px; }
    .ms-hero-empty-txt strong { display: block; font-family: 'Fraunces', serif; font-weight: 500; font-size: 18px; letter-spacing: -0.01em; }
    .ms-hero-empty-txt span { display: block; font-size: 12.5px; color: var(--ms-muted); margin-top: 2px; }
    .ms-hero-result { display: none; align-items: center; gap: 18px; }
    .ms-hero-result.is-shown { display: flex; animation: msFade .35s var(--ms-ease); }
    .ms-hero-badge {
      position: relative; flex-shrink: 0; width: 84px; height: 84px; border-radius: 18px;
      background: #fff; border: 1px solid var(--ms-line-2);
      color: var(--ms-ink); display: flex; flex-direction: column; align-items: center; justify-content: center;
      box-shadow: var(--ms-shadow); animation: msFade .35s var(--ms-ease);
    }
    .ms-hero-badge .ms-badge-label { font-size: 8.5px; letter-spacing: 0.18em; text-transform: uppercase; color: var(--ms-muted); margin-bottom: 1px; }
    .ms-hero-badge .ms-badge-size { font-family: 'Fraunces', serif; font-weight: 400; font-size: 38px; line-height: 1; color: var(--ms-accent); }
    .ms-hero-info { flex: 1; min-width: 0; }
    .ms-hero-info .ms-hero-eyebrow { font-size: 10.5px; font-weight: 600; letter-spacing: 0.16em; text-transform: uppercase; color: var(--ms-accent); margin: 0 0 4px; }
    .ms-hero-info h3 { font-family: 'Fraunces', serif; font-weight: 400; font-size: clamp(19px, 4.5cqw, 23px); letter-spacing: -0.01em; margin: 0 0 6px; line-height: 1.15; }
    .ms-hero-info h3 b { font-weight: 600; }
    .ms-hero-conv { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 7px; }
    .ms-chip {
      display: inline-flex; align-items: center; gap: 4px; padding: 4px 9px;
      background: #fff; border: 1px solid var(--ms-line-2); border-radius: 999px;
      font-size: 11.5px; font-weight: 600; color: var(--ms-ink-2);
    }
    .ms-chip b { color: var(--ms-muted); font-weight: 600; }
    .ms-hero-basis { font-size: 11.5px; color: var(--ms-muted); line-height: 1.4; margin: 0; }
    .ms-hero-between { display: none; align-items: flex-start; gap: 12px; }
    .ms-hero-between.is-shown { display: flex; animation: msFade .4s var(--ms-ease); }
    .ms-hero-between .ms-hero-mark { width: 42px; height: 42px; border-radius: 12px; flex-shrink: 0; background: #fff; border: 1px solid var(--ms-line-2); display: flex; align-items: center; justify-content: center; color: var(--ms-accent); }
    .ms-hero-between .ms-hero-mark svg { width: 22px; height: 22px; }
    .ms-hero-between strong { display: block; font-family: 'Fraunces', serif; font-weight: 500; font-size: 16px; margin-bottom: 2px; }
    .ms-hero-between span { font-size: 12.5px; color: var(--ms-muted); }
    .ms-body { padding: 18px 22px 20px; }
    .ms-body-label {
      display: flex; align-items: center; justify-content: space-between;
      font-size: 10.5px; font-weight: 600; letter-spacing: 0.12em; text-transform: uppercase;
      color: var(--ms-muted); margin: 0 0 11px;
    }
    .ms-measure-link {
      background: transparent; border: 0; color: var(--ms-accent); font-size: 11px; font-weight: 600;
      letter-spacing: 0.04em; text-transform: uppercase; padding: 2px; display: inline-flex; align-items: center; gap: 5px;
      transition: color .2s ease;
    }
    .ms-measure-link:hover { color: var(--ms-accent-deep); }
    .ms-measure-link svg { width: 13px; height: 13px; }
    .ms-finder-grid {
      display: grid; grid-template-columns: repeat(4, 1fr); gap: 9px;
      align-items: end;
    }
    .ms-input-group {
      display: flex !important; flex-direction: column !important; gap: 5px !important;
      margin: 0 !important; padding: 0 !important; min-width: 0;
    }
    .ms-input-group label {
      font-size: 11.5px !important; font-weight: 600 !important; color: var(--ms-ink-2) !important;
      display: flex !important; align-items: center; gap: 4px;
      margin: 0 !important; padding: 0 !important;
      line-height: 1.25 !important; min-height: 30px;
      text-transform: none !important; letter-spacing: normal !important;
    }
    .ms-input-group .ms-hint { color: var(--ms-muted) !important; font-weight: 500 !important; font-size: 10px !important; }
    .ms-input-shell { position: relative; width: 100%; }
    .ms-input {
      -webkit-appearance: none !important; appearance: none !important;
      background: var(--ms-surface) !important; border: 1.5px solid var(--ms-line-2) !important;
      border-radius: var(--ms-radius) !important; padding: 11px 12px !important;
      font-size: 16px !important; font-family: inherit !important; line-height: 1.2 !important;
      color: var(--ms-ink) !important; width: 100% !important;
      height: 46px !important; min-height: 46px !important; max-height: 46px !important;
      margin: 0 !important; box-shadow: none;
      transition: border-color .2s var(--ms-ease), box-shadow .2s var(--ms-ease), background .2s var(--ms-ease);
    }
    .ms-input::placeholder { color: #c4bcab; }
    .ms-input:focus { outline: none; border-color: var(--ms-accent); background: #fff; box-shadow: 0 0 0 3px rgba(168,118,63,0.18); }
    .ms-input.is-matched { border-color: var(--ms-accent); background: #fff; }
    .ms-input-check {
      position: absolute; right: 9px; top: 50%; transform: translateY(-50%) scale(.5);
      width: 18px; height: 18px; border-radius: 50%; background: var(--ms-accent); color: #fff;
      display: flex; align-items: center; justify-content: center; opacity: 0;
      transition: opacity .2s var(--ms-ease), transform .25s var(--ms-ease); pointer-events: none;
    }
    .ms-input-check svg { width: 11px; height: 11px; }
    .ms-input-group.is-matched .ms-input-check { opacity: 1; transform: translateY(-50%) scale(1); }
    .ms-fit { display: none; align-items: center; gap: 10px; margin-top: 16px; padding-top: 16px; border-top: 1px dashed var(--ms-line-2); animation: msFade .4s var(--ms-ease); }
    .ms-fit.is-shown { display: flex; flex-wrap: wrap; }
    .ms-fit-label { font-size: 11.5px; font-weight: 600; letter-spacing: 0.04em; text-transform: uppercase; color: var(--ms-muted); }
    .ms-fit-opts { display: inline-flex; gap: 6px; }
    .ms-fit-btn {
      border: 1.5px solid var(--ms-line-2); background: #fff; color: var(--ms-ink-2);
      border-radius: 999px; padding: 7px 14px; font-size: 12.5px; font-weight: 600;
      transition: all .2s var(--ms-ease);
    }
    .ms-fit-btn:hover { border-color: var(--ms-accent); }
    .ms-fit-btn.is-active { background: var(--ms-accent-soft); border-color: var(--ms-accent); color: var(--ms-accent-deep); }
    .ms-reset { margin-left: auto; background: transparent; border: 0; color: var(--ms-muted); font-size: 11.5px; font-weight: 600; letter-spacing: 0.04em; text-transform: uppercase; padding: 6px 2px; text-decoration: underline; text-underline-offset: 3px; }
    .ms-reset:hover { color: var(--ms-ink); }
    .ms-measure-panel { max-height: 0; overflow: hidden; transition: max-height .4s var(--ms-ease); }
    .ms-measure-panel.is-open { max-height: 360px; }
    .ms-measure-inner { margin-top: 14px; padding: 14px 16px; background: var(--ms-surface); border-radius: var(--ms-radius-lg); border: 1px solid var(--ms-line); }
    .ms-measure-list { list-style: none; padding: 0; margin: 0; display: grid; grid-template-columns: 1fr; gap: 9px; }
    @media (min-width: 560px) { .ms-measure-list { grid-template-columns: 1fr 1fr; } }
    .ms-measure-list li { display: flex; align-items: flex-start; gap: 8px; font-size: 12.5px; color: var(--ms-ink-2); line-height: 1.4; }
    .ms-measure-list strong { display: inline-block; min-width: 54px; font-weight: 600; color: var(--ms-ink); }
    .ms-chart-head {
      display: flex; align-items: center; justify-content: space-between; gap: 10px;
      padding: 14px 22px; border-top: 1px solid var(--ms-line); background: var(--ms-surface);
    }
    .ms-chart-head h4 { font-size: 11px; font-weight: 600; letter-spacing: 0.12em; text-transform: uppercase; color: var(--ms-muted); margin: 0; }
    .ms-chart-toggle { background: transparent; border: 0; color: var(--ms-ink-2); font-size: 11.5px; font-weight: 600; display: inline-flex; align-items: center; gap: 5px; }
    .ms-chart-toggle svg { width: 14px; height: 14px; transition: transform .3s var(--ms-ease); }
    .ms-chart-collapsed .ms-chart-toggle svg { transform: rotate(-90deg); }
    .ms-table-shell { max-height: 1400px; overflow: hidden; transition: max-height .45s var(--ms-ease); }
    .ms-chart-collapsed .ms-table-shell { max-height: 0; }
    .ms-table-wrap { overflow-x: auto; -webkit-overflow-scrolling: touch; }
    table { width: 100%; border-collapse: collapse; }
    th, td {
      padding: 11px 14px; text-align: left; font-size: 13.5px;
      border-bottom: 1px solid var(--ms-line); white-space: nowrap; line-height: 1.3;
    }
    th:first-child, td:first-child { padding-left: 22px; }
    th:last-child, td:last-child { padding-right: 22px; }
    th { background: #fff; font-weight: 600; font-size: 10px; letter-spacing: 0.1em; text-transform: uppercase; color: var(--ms-muted); padding-top: 11px; padding-bottom: 11px; }
    tbody tr:last-child td { border-bottom: 0; }
    tbody tr { transition: opacity .25s var(--ms-ease), background .25s var(--ms-ease); }
    tbody tr.is-dimmed { opacity: 0.32; }
    td:first-child { font-family: 'Fraunces', serif; font-size: 17px; font-weight: 400; }
    tbody tr.is-recommended { background: var(--ms-accent-soft); position: relative; opacity: 1; }
    tbody tr.is-recommended td { border-color: #e6d6bd; }
    tbody tr.is-recommended td:first-child::before { content: ''; position: absolute; left: 0; top: 0; bottom: 0; width: 3px; background: var(--ms-accent); }
    .ms-rec-tag {
      display: inline-block; margin-left: 7px; padding: 2px 7px; background: var(--ms-accent); color: #fff;
      font-family: -apple-system, sans-serif; font-size: 9px; font-weight: 700; letter-spacing: 0.08em;
      text-transform: uppercase; border-radius: 3px; vertical-align: middle;
    }
    @media (max-width: 520px) {
      th, td { padding: 9px 10px; font-size: 12.5px; }
      th:first-child, td:first-child { padding-left: 16px; }
      th:last-child, td:last-child { padding-right: 16px; }
      td:first-child { font-size: 15px; }
      .ms-input-group label .ms-hint { display: none; }
      .ms-input { padding: 11px 8px !important; }
      .ms-hero-badge { width: 72px; height: 72px; }
      .ms-hero-badge .ms-badge-size { font-size: 32px; }
      .ms-body, .ms-hero { padding-left: 16px; padding-right: 16px; }
      .ms-chart-head { padding-left: 16px; padding-right: 16px; }
    }
    .ms-help-line { text-align: center; font-size: 12.5px; color: var(--ms-muted); margin: 16px 0 0; }
    .ms-help-line a { color: var(--ms-ink); text-decoration: underline; text-underline-offset: 3px; font-weight: 600; }
    @media print { .ms-toggles, .ms-body, .ms-hero, .ms-chart-head, .ms-help-line { display: none !important; } .ms-table-shell { max-height: none !important; } }
  </style>
  <div class="ms-sg">
    <header class="ms-head">
      <p class="ms-kicker">Anguissa Fit Studio</p>
      <h1>Find your <em>perfect</em> size</h1>
    </header>
    <div class="ms-toggles">
      <div class="ms-segment" role="tablist" aria-label="Gender">
        <button type="button" class="is-active" data-gender="women">Women</button>
        <button type="button" data-gender="men">Men</button>
      </div>
      <div class="ms-segment" role="tablist" aria-label="Category">
        <button type="button" class="is-active" data-category="general">Tops</button>
        <button type="button" data-category="pants">Pants</button>
        <button type="button" data-category="shoes">Shoes</button>
      </div>
      <div class="ms-segment ms-seg-unit ms-table-unit" role="tablist" aria-label="Units">
        <button type="button" class="is-active" data-unit="cm">cm</button>
        <button type="button" data-unit="in">in</button>
      </div>
    </div>
    <div class="ms-card">
      <div class="ms-hero">
        <div class="ms-hero-empty" id="ms-hero-empty">
          <div class="ms-hero-mark" aria-hidden="true">
            <svg viewbox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M21.3 8.7l-9.6 9.6c-.8.8-2 .8-2.7 0L3.7 12c-.8-.8-.8-2 0-2.7l5-5c.8-.8 2-.8 2.7 0l9.9 9.9c.7.7.7 1.9 0 2.6z"></path><path d="M7 7l2 2M11 11l2 2M15 15l2 2"></path></svg>
          </div>
          <div class="ms-hero-empty-txt">
            <strong>Your size, instantly.</strong>
            <span>Enter a measurement or two below — we'll do the rest.</span>
          </div>
        </div>
        <div class="ms-hero-result" id="ms-hero-result" aria-live="polite">
          <div class="ms-hero-badge">
            <span class="ms-badge-label">Size</span>
            <span class="ms-badge-size" id="ms-badge-size">M</span>
          </div>
          <div class="ms-hero-info">
            <p class="ms-hero-eyebrow">Your recommended fit</p>
            <h3 id="ms-hero-headline">You're a <b>Medium</b></h3>
            <div class="ms-hero-conv" id="ms-hero-conv"></div>
            <p class="ms-hero-basis" id="ms-hero-basis"></p>
          </div>
        </div>
        <div class="ms-hero-between" id="ms-hero-between" aria-live="polite">
          <div class="ms-hero-mark" aria-hidden="true">
            <svg viewbox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><path d="M12 8v4M12 16h.01"></path></svg>
          </div>
          <div>
            <strong>You're between sizes</strong>
            <span id="ms-between-txt">Check the chart below, or email us and we'll help you choose.</span>
          </div>
        </div>
      </div>
      <div class="ms-body">
        <p class="ms-body-label">
          Your measurements
          <button type="button" class="ms-measure-link" id="ms-measure-toggle" aria-expanded="false">
            <svg viewbox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M12 16v-4M12 8h.01"></path></svg>
            How to measure
          </button>
        </p>
        <div class="ms-finder-grid">
          <div class="ms-input-group" data-key="bust">
            <label for="ms-bust"><span data-bust-label>Bust</span> <span class="ms-hint ms-finder-unit">cm</span></label>
            <div class="ms-input-shell">
              <input id="ms-bust" type="number" inputmode="decimal" step="0.5" placeholder="91" class="ms-input">
              <span class="ms-input-check"><svg viewbox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg></span>
            </div>
          </div>
          <div class="ms-input-group" data-key="waist">
            <label for="ms-waist">Waist <span class="ms-hint ms-finder-unit">cm</span></label>
            <div class="ms-input-shell">
              <input id="ms-waist" type="number" inputmode="decimal" step="0.5" placeholder="74" class="ms-input">
              <span class="ms-input-check"><svg viewbox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg></span>
            </div>
          </div>
          <div class="ms-input-group" data-key="hips">
            <label for="ms-hips">Hips <span class="ms-hint ms-finder-unit">cm</span></label>
            <div class="ms-input-shell">
              <input id="ms-hips" type="number" inputmode="decimal" step="0.5" placeholder="99" class="ms-input">
              <span class="ms-input-check"><svg viewbox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg></span>
            </div>
          </div>
          <div class="ms-input-group" data-key="inseam">
            <label for="ms-inseam">Inseam <span class="ms-hint ms-finder-unit">cm</span></label>
            <div class="ms-input-shell">
              <input id="ms-inseam" type="number" inputmode="decimal" step="0.5" placeholder="—" class="ms-input">
              <span class="ms-input-check"><svg viewbox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg></span>
            </div>
          </div>
        </div>
        <div class="ms-fit" id="ms-fit">
          <span class="ms-fit-label">Preferred fit</span>
          <span class="ms-fit-opts">
            <button type="button" class="ms-fit-btn" data-fit="down">Fitted</button>
            <button type="button" class="ms-fit-btn is-active" data-fit="true">True to size</button>
            <button type="button" class="ms-fit-btn" data-fit="up">Relaxed</button>
          </span>
          <button type="button" class="ms-reset" id="ms-reset">Clear</button>
        </div>
        <div class="ms-measure-panel" id="ms-measure-panel">
          <div class="ms-measure-inner">
            <ul class="ms-measure-list">
              <li><strong>Bust</strong> Around the fullest part, tape level under the arms.</li>
              <li><strong>Waist</strong> At your natural waistline — the narrowest point.</li>
              <li><strong>Hips</strong> Fullest part, ~20cm (8") below the waist.</li>
              <li><strong>Inseam</strong> Inner thigh down to your desired length.</li>
              <li><strong>Foot</strong> Heel to longest toe, against a wall.</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="ms-chart-head">
        <h4 id="ms-chart-title">Full size chart</h4>
        <button type="button" class="ms-chart-toggle" id="ms-chart-toggle" aria-expanded="true">
          <span id="ms-chart-toggle-txt">Hide</span>
          <svg viewbox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
        </button>
      </div>
      <div class="ms-table-shell" id="ms-table-shell">
        <div class="ms-table-wrap">
          <table id="ms-table" aria-label="Size chart"></table>
        </div>
      </div>
    </div>
    <p class="ms-help-line">
      Still unsure? Email <a href="mailto:support@anguissa.com">support@anguissa.com</a> — we reply within 24h.
    </p>
  </div>`;
  function boot() {
    var host = document.getElementById('anguissa-fit-host');
    if (!host || host.shadowRoot) return;
    if (!document.getElementById('ms-fraunces-font')) {
      var link = document.createElement('link');
      link.id = 'ms-fraunces-font';
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,300;9..144,400;9..144,500;9..144,600;9..144,700&display=swap';
      document.head.appendChild(link);
    }
    // The host is empty in the light DOM; some themes hide empty elements,
    // collapsing the widget to 0 height. Force it visible.
    host.style.display = 'block';
    host.style.minHeight = '1px';
    var shadow = host.attachShadow({ mode: 'open' });
    shadow.innerHTML = WIDGET_HTML;
    (function (root) {
      'use strict';
      if (!root) return;
      var SIZE_NAMES = { 'XXS':'Double XS','XS':'Extra Small','S':'Small','M':'Medium','L':'Large','XL':'Extra Large','XXL':'Double XL','2XL':'Double XL','XXXL':'Triple XL','3XL':'Triple XL','4XL':'4X Large','5XL':'5X Large' };
      var DATA = {
        women: {
          general: { keys: ['bust'], labels: { bust: 'Bust' },
            rows: [
              { code: 'XXS', au: '4',     us: '0',     in: { bust: [29, 31] }, cm: { bust: [74, 78] } },
              { code: 'XS',  au: '6',     us: '2',     in: { bust: [31, 32] }, cm: { bust: [78, 82] } },
              { code: 'S',   au: '8-10',  us: '4-6',   in: { bust: [32, 35] }, cm: { bust: [82, 88] } },
              { code: 'M',   au: '12-14', us: '8-10',  in: { bust: [35, 37] }, cm: { bust: [88, 94] } },
              { code: 'L',   au: '16-18', us: '12-14', in: { bust: [37, 39] }, cm: { bust: [94, 100] } },
              { code: 'XL',  au: '20',    us: '16',    in: { bust: [39, 42] }, cm: { bust: [100, 106] } },
              { code: '2XL', au: '22',    us: '18',    in: { bust: [42, 44] }, cm: { bust: [106, 112] } },
              { code: '3XL', au: '24',    us: '20',    in: { bust: [44, 46] }, cm: { bust: [112, 118] } },
              { code: '4XL', au: '26',    us: '22',    in: { bust: [46, 49] }, cm: { bust: [118, 124] } },
              { code: '5XL', au: '28',    us: '24',    in: { bust: [49, 52] }, cm: { bust: [124, 132] } }
            ]
          },
          pants: { keys: ['waist', 'hips', 'inseam'], labels: { waist: 'Waist', hips: 'Hips', inseam: 'Inseam' },
            rows: [
              { code: 'XXS', au: '2',     us: '00',    in: { waist: [22, 23], hips: [32, 33], inseam: [28, 30] }, cm: { waist: [56, 59], hips: [81, 84],  inseam: [71, 76] } },
              { code: 'XS',  au: '4-6',   us: '0-2',   in: { waist: [24, 25], hips: [34, 35], inseam: [28, 30] }, cm: { waist: [61, 64], hips: [86, 89],  inseam: [71, 76] } },
              { code: 'S',   au: '8-10',  us: '4-6',   in: { waist: [26, 27], hips: [36, 37], inseam: [29, 31] }, cm: { waist: [66, 69], hips: [91, 94],  inseam: [74, 79] } },
              { code: 'M',   au: '12-14', us: '8-10',  in: { waist: [28, 29], hips: [38, 39], inseam: [29, 31] }, cm: { waist: [71, 74], hips: [97, 99],  inseam: [74, 79] } },
              { code: 'L',   au: '16-18', us: '12-14', in: { waist: [30, 32], hips: [40, 42], inseam: [30, 32] }, cm: { waist: [76, 81], hips: [102, 107], inseam: [76, 81] } },
              { code: 'XL',  au: '20-22', us: '16-18', in: { waist: [33, 35], hips: [43, 45], inseam: [30, 32] }, cm: { waist: [84, 89], hips: [109, 114], inseam: [76, 81] } },
              { code: 'XXL', au: '24-26', us: '20-22', in: { waist: [36, 38], hips: [46, 48], inseam: [31, 33] }, cm: { waist: [91, 97], hips: [117, 122], inseam: [79, 84] } },
              { code: '3XL', au: '28-30', us: '24-26', in: { waist: [39, 41], hips: [49, 51], inseam: [31, 33] }, cm: { waist: [99, 104], hips: [124, 129], inseam: [79, 84] } },
              { code: '4XL', au: '32-34', us: '28-30', in: { waist: [42, 44], hips: [52, 54], inseam: [32, 34] }, cm: { waist: [106, 112], hips: [132, 137], inseam: [81, 86] } },
              { code: '5XL', au: '36-38', us: '32-34', in: { waist: [45, 47], hips: [55, 57], inseam: [32, 34] }, cm: { waist: [114, 119], hips: [139, 144], inseam: [81, 86] } }
            ]
          }
        },
        men: {
          general: { keys: ['chest', 'waist', 'hips'], labels: { chest: 'Chest', waist: 'Waist', hips: 'Hips' },
            rows: [
              { code: 'XXS',  in: { chest: [32, 34], waist: [26, 28], hips: [32, 34] } },
              { code: 'XS',   in: { chest: [34, 36], waist: [28, 30], hips: [34, 36] } },
              { code: 'S',    in: { chest: [36, 38], waist: [30, 32], hips: [36, 38] } },
              { code: 'M',    in: { chest: [38, 40], waist: [32, 34], hips: [38, 40] } },
              { code: 'L',    in: { chest: [40, 42], waist: [34, 36], hips: [40, 42] } },
              { code: 'XL',   in: { chest: [42, 44], waist: [36, 38], hips: [42, 44] } },
              { code: 'XXL',  in: { chest: [44, 46], waist: [38, 40], hips: [44, 46] } },
              { code: 'XXXL', in: { chest: [46, 48], waist: [40, 42], hips: [46, 48] } },
              { code: '4XL',  in: { chest: [48, 51], waist: [42, 45], hips: [48, 51] } },
              { code: '5XL',  in: { chest: [51, 54], waist: [45, 48], hips: [51, 54] } }
            ]
          },
          pants: { keys: ['waist', 'hips', 'inseam'], labels: { waist: 'Waist', hips: 'Hips', inseam: 'Inseam' },
            rows: [
              { code: 'XXS',  in: { waist: [26, 27], hips: [32, 34], inseam: [28, 30] }, cm: { waist: [66, 69],   hips: [81, 86],   inseam: [71, 76] } },
              { code: 'XS',   in: { waist: [28, 29], hips: [34, 36], inseam: [28, 30] }, cm: { waist: [71, 74],   hips: [86, 91],   inseam: [71, 76] } },
              { code: 'S',    in: { waist: [30, 31], hips: [36, 38], inseam: [30, 32] }, cm: { waist: [76, 79],   hips: [91, 97],   inseam: [76, 81] } },
              { code: 'M',    in: { waist: [32, 34], hips: [38, 40], inseam: [30, 32] }, cm: { waist: [81, 86],   hips: [97, 102],  inseam: [76, 81] } },
              { code: 'L',    in: { waist: [35, 37], hips: [40, 42], inseam: [32, 34] }, cm: { waist: [89, 94],   hips: [102, 107], inseam: [81, 86] } },
              { code: 'XL',   in: { waist: [38, 40], hips: [42, 44], inseam: [32, 34] }, cm: { waist: [97, 102],  hips: [107, 112], inseam: [81, 86] } },
              { code: 'XXL',  in: { waist: [41, 43], hips: [44, 46], inseam: [34, 36] }, cm: { waist: [104, 109], hips: [112, 117], inseam: [86, 91] } },
              { code: 'XXXL', in: { waist: [44, 46], hips: [46, 48], inseam: [34, 36] }, cm: { waist: [112, 117], hips: [117, 122], inseam: [86, 91] } },
              { code: '4XL',  in: { waist: [47, 49], hips: [49, 51], inseam: [35, 37] }, cm: { waist: [119, 124], hips: [124, 129], inseam: [89, 94] } },
              { code: '5XL',  in: { waist: [50, 52], hips: [52, 54], inseam: [35, 37] }, cm: { waist: [127, 132], hips: [132, 137], inseam: [89, 94] } }
            ]
          }
        },
        shoes: {
          women: { rows: [
            { au: 4, cn: 34, eu: 35, us: '4.5', uk: 2, jp: 21.5 },
            { au: 5, cn: 35, eu: 36, us: '5.5', uk: 3, jp: 22.5 },
            { au: 6, cn: 36, eu: 37, us: '6.5', uk: 4, jp: 23.5 },
            { au: 7, cn: 38, eu: 38, us: '7.5', uk: 5, jp: 24.0 },
            { au: 8, cn: 39, eu: 39, us: '8.5', uk: 6, jp: 25.0 },
            { au: 9, cn: 40, eu: 40, us: '9.5', uk: 7, jp: 25.5 },
            { au: 10, cn: 41, eu: 41, us: '10.5', uk: 8, jp: 26.5 },
            { au: 11, cn: 42, eu: 42, us: '11.5', uk: 9, jp: 27.0 }
          ]},
          men: { rows: [
            { au: 5, cn: 38, eu: 38, us: 6, uk: 5, jp: 24.0 },
            { au: 6, cn: 39, eu: 39, us: 7, uk: 6, jp: 24.5 },
            { au: 7, cn: 40, eu: 40, us: 8, uk: 7, jp: 25.0 },
            { au: 8, cn: 41, eu: 41, us: 9, uk: 8, jp: 26.0 },
            { au: 9, cn: 42, eu: 42, us: 10, uk: 9, jp: 27.0 },
            { au: 10, cn: 43, eu: 43, us: 11, uk: 10, jp: 28.0 },
            { au: 11, cn: 44, eu: 44, us: 12, uk: 11, jp: 28.5 },
            { au: 12, cn: 45, eu: 45, us: 13, uk: 12, jp: 29.0 }
          ]}
        }
      };
      var state = { gender: 'women', category: 'general', unit: 'cm', finderUnit: 'cm', recommended: null, hasResult: false, fit: 'true' };
      function inToCm(v) { return Math.round(v * 2.54); }
      function cmToIn(v) { return v / 2.54; }
      function getRange(row, key, unit) {
        if (unit === 'in') return row.in[key];
        if (row.cm && row.cm[key]) return row.cm[key];
        var r = row.in[key]; return [inToCm(r[0]), inToCm(r[1])];
      }
      function fmt(v) { return Number.isInteger(v) ? v.toString() : v.toFixed(1); }
      function fmtRange(r) { return fmt(r[0]) + '-' + fmt(r[1]); }
      function sizeRank(c) { return ({'XXS':0,'XS':1,'S':2,'M':3,'L':4,'XL':5,'XXL':6,'2XL':6,'XXXL':7,'3XL':7,'4XL':8,'5XL':9})[c] || 0; }
      var ORDER = ['XXS','XS','S','M','L','XL','XXL','XXXL','4XL','5XL'];
      function translateSize(c, cat, g) {
        if (cat === 'general' && g === 'women') { if (c === 'XXL') return '2XL'; if (c === 'XXXL') return '3XL'; }
        else { if (c === '2XL') return 'XXL'; if (c === '3XL') return 'XXXL'; }
        return c;
      }
      function applyFit(code) {
        if (state.fit === 'true') return code;
        var idx = ORDER.indexOf(code === '2XL' ? 'XXL' : code === '3XL' ? 'XXXL' : code);
        if (idx === -1) return code;
        if (state.fit === 'up') idx = Math.min(ORDER.length - 1, idx + 1);
        if (state.fit === 'down') idx = Math.max(0, idx - 1);
        return ORDER[idx];
      }
      function updateUnitToggleVisibility() {
        var u = root.querySelector('.ms-table-unit');
        if (u) u.style.display = state.category === 'shoes' ? 'none' : '';
      }
      function setChartTitle() {
        var t = root.querySelector('#ms-chart-title');
        if (t) t.textContent = state.hasResult && state.recommended ? 'Your match, highlighted' : 'Full size chart';
      }
      function renderTable() {
        updateUnitToggleVisibility();
        setChartTitle();
        if (state.category === 'shoes') return renderShoesTable();
        var ds = DATA[state.gender][state.category];
        var keys = ds.keys, unit = state.unit, ul = unit === 'in' ? 'in' : 'cm', isW = state.gender === 'women';
        var table = root.querySelector('#ms-table');
        var thead = '<thead><tr><th>Size</th>';
        if (isW) { thead += '<th>AU</th><th>US</th>'; }
        keys.forEach(function(k) { thead += '<th>' + ds.labels[k] + ' (' + ul + ')</th>'; });
        thead += '</tr></thead>';
        var tbody = '<tbody>';
        ds.rows.forEach(function(row) {
          var isRec = state.recommended && state.recommended === row.code;
          var dim = state.hasResult && state.recommended && !isRec ? ' is-dimmed' : '';
          tbody += '<tr class="' + (isRec ? 'is-recommended' : '') + dim + '">';
          tbody += '<td>' + row.code + (isRec ? '<span class="ms-rec-tag">You</span>' : '') + '</td>';
          if (isW) { tbody += '<td>' + (row.au || '') + '</td><td>' + (row.us || '') + '</td>'; }
          keys.forEach(function(k) { tbody += '<td>' + fmtRange(getRange(row, k, unit)) + '</td>'; });
          tbody += '</tr>';
        });
        tbody += '</tbody>';
        table.innerHTML = thead + tbody;
      }
      function renderShoesTable() {
        var rows = DATA.shoes[state.gender].rows;
        var table = root.querySelector('#ms-table');
        var thead = '<thead><tr><th>AU</th><th>CN</th><th>EU</th><th>US</th><th>UK</th><th>JP (cm)</th></tr></thead>';
        var tbody = '<tbody>';
        rows.forEach(function(r) {
          tbody += '<tr><td>' + r.au + '</td><td>' + r.cn + '</td><td>' + r.eu + '</td><td>' + r.us + '</td><td>' + r.uk + '</td><td>' + r.jp.toFixed(1) + '</td></tr>';
        });
        tbody += '</tbody>';
        table.innerHTML = thead + tbody;
      }
      function markMatchedInputs(matched) {
        root.querySelectorAll('.ms-input-group').forEach(function(g) {
          var k = g.getAttribute('data-key');
          g.classList.toggle('is-matched', !!matched[k]);
          var inp = g.querySelector('.ms-input');
          if (inp) inp.classList.toggle('is-matched', !!matched[k]);
        });
      }
      function showState(which) {
        root.querySelector('#ms-hero-empty').style.display = which === 'empty' ? '' : 'none';
        root.querySelector('#ms-hero-result').classList.toggle('is-shown', which === 'result');
        root.querySelector('#ms-hero-between').classList.toggle('is-shown', which === 'between');
        root.querySelector('#ms-fit').classList.toggle('is-shown', which === 'result');
      }
      function findSize() {
        var unit = state.finderUnit;
        var inputs = {
          bust: parseFloat(root.querySelector('#ms-bust').value),
          waist: parseFloat(root.querySelector('#ms-waist').value),
          hips: parseFloat(root.querySelector('#ms-hips').value),
          inseam: parseFloat(root.querySelector('#ms-inseam').value)
        };
        Object.keys(inputs).forEach(function(k) { if (!isNaN(inputs[k]) && unit === 'cm') inputs[k] = cmToIn(inputs[k]); });
        if (state.gender === 'men' && !isNaN(inputs.bust)) inputs.chest = inputs.bust;
        var hasAny = ['bust','waist','hips','inseam'].some(function(k) { return !isNaN(inputs[k]); });
        if (!hasAny) {
          state.recommended = null; state.hasResult = false;
          markMatchedInputs({}); showState('empty'); renderTable(); return;
        }
        var datasets = [DATA[state.gender].general, DATA[state.gender].pants];
        var perKey = {}, matchedKeys = {};
        datasets.forEach(function(ds) {
          ds.keys.forEach(function(key) {
            var input = inputs[key];
            if (isNaN(input)) return;
            ds.rows.forEach(function(row) {
              var rg = row.in[key];
              if (input >= rg[0] && input <= rg[1]) {
                matchedKeys[key === 'chest' ? 'bust' : key] = true;
                if (!perKey[key] || sizeRank(row.code) > sizeRank(perKey[key])) perKey[key] = row.code;
              }
            });
          });
        });
        markMatchedInputs(matchedKeys);
        var cands = Object.keys(perKey).map(function(k) { return perKey[k]; });
        if (!cands.length) {
          state.recommended = null; state.hasResult = false;
          showState('between'); renderTable(); return;
        }
        var baseSize = cands.reduce(function(a, s) { return sizeRank(s) > sizeRank(a) ? s : a; });
        if (state.category === 'shoes') { state.category = !isNaN(inputs.inseam) ? 'pants' : 'general'; }
        else if (!isNaN(inputs.inseam) && state.category !== 'pants') { state.category = 'pants'; }
        root.querySelectorAll('[data-category]').forEach(function(b) { b.classList.toggle('is-active', b.dataset.category === state.category); });
        var fitted = applyFit(baseSize === '2XL' ? 'XXL' : baseSize === '3XL' ? 'XXXL' : baseSize);
        var finalSize = translateSize(fitted, state.category, state.gender);
        state.recommended = finalSize;
        state.hasResult = true;
        renderTable();
        root.querySelector('#ms-badge-size').textContent = finalSize;
        var nm = SIZE_NAMES[finalSize] || finalSize;
        var fitWord = state.fit === 'up' ? ' for a relaxed fit' : state.fit === 'down' ? ' for a fitted look' : '';
        root.querySelector('#ms-hero-headline').innerHTML = 'You’re a <b>' + nm + '</b>' + fitWord;
        var conv = root.querySelector('#ms-hero-conv'); conv.innerHTML = '';
        if (state.gender === 'women') {
          var rf = DATA.women[state.category].rows.filter(function(r) { return translateSize(r.code, state.category, 'women') === finalSize; })[0];
          if (rf) {
            conv.innerHTML = '<span class="ms-chip"><b>AU</b> ' + rf.au + '</span><span class="ms-chip"><b>US</b> ' + rf.us + '</span>';
          }
        }
        var breakdown = [];
        ['bust','waist','hips','inseam'].forEach(function(k) {
          var v = inputs[k];
          if (!isNaN(v)) {
            var dv = state.finderUnit === 'cm' ? inToCm(v) : v;
            var lbl = (k === 'bust' && state.gender === 'men') ? 'Chest' : k.charAt(0).toUpperCase() + k.slice(1);
            breakdown.push(lbl + ' ' + fmt(dv) + state.finderUnit);
          }
        });
        root.querySelector('#ms-hero-basis').textContent = 'Based on ' + breakdown.join(' · ');
        showState('result');
      }
      function updateBustLabel() {
        var l = root.querySelector('[data-bust-label]');
        if (l) l.textContent = state.gender === 'men' ? 'Chest' : 'Bust';
      }
      var mt = root.querySelector('#ms-measure-toggle'), mp = root.querySelector('#ms-measure-panel');
      if (mt && mp) mt.addEventListener('click', function() {
        var open = mp.classList.toggle('is-open');
        mt.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      var ct = root.querySelector('#ms-chart-toggle'), card = root.querySelector('.ms-card');
      if (ct && card) ct.addEventListener('click', function() {
        var collapsed = card.classList.toggle('ms-chart-collapsed');
        ct.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        root.querySelector('#ms-chart-toggle-txt').textContent = collapsed ? 'Show' : 'Hide';
      });
      root.querySelectorAll('[data-gender]').forEach(function(b) {
        b.addEventListener('click', function() {
          root.querySelectorAll('[data-gender]').forEach(function(x) { x.classList.remove('is-active'); });
          b.classList.add('is-active'); state.gender = b.dataset.gender; updateBustLabel(); findSize();
        });
      });
      root.querySelectorAll('[data-category]').forEach(function(b) {
        b.addEventListener('click', function() {
          root.querySelectorAll('[data-category]').forEach(function(x) { x.classList.remove('is-active'); });
          b.classList.add('is-active'); state.category = b.dataset.category; findSize();
        });
      });
      root.querySelectorAll('[data-unit]').forEach(function(b) {
        b.addEventListener('click', function() {
          root.querySelectorAll('[data-unit]').forEach(function(x) { x.classList.remove('is-active'); });
          b.classList.add('is-active'); state.unit = b.dataset.unit; state.finderUnit = b.dataset.unit;
          var t = state.finderUnit === 'in' ? 'in' : 'cm';
          root.querySelectorAll('.ms-finder-unit').forEach(function(el) { el.textContent = t; });
          findSize();
        });
      });
      root.querySelectorAll('[data-fit]').forEach(function(b) {
        b.addEventListener('click', function() {
          root.querySelectorAll('[data-fit]').forEach(function(x) { x.classList.remove('is-active'); });
          b.classList.add('is-active'); state.fit = b.dataset.fit; findSize();
        });
      });
      var typingTimer;
      root.querySelectorAll('.ms-input').forEach(function(i) {
        i.addEventListener('input', function() { clearTimeout(typingTimer); typingTimer = setTimeout(findSize, 180); });
      });
      root.querySelector('#ms-reset').addEventListener('click', function() {
        ['#ms-bust','#ms-waist','#ms-hips','#ms-inseam'].forEach(function(s) { root.querySelector(s).value = ''; });
        state.recommended = null; state.hasResult = false; state.fit = 'true';
        root.querySelectorAll('[data-fit]').forEach(function(x) { x.classList.toggle('is-active', x.dataset.fit === 'true'); });
        markMatchedInputs({}); showState('empty'); renderTable();
      });
      updateBustLabel();
      showState('empty');
      renderTable();
    })(shadow.querySelector('.ms-sg'));
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-mount when Shopify's theme editor (re)loads a section containing the widget.
  document.addEventListener('shopify:section:load', boot);
})();
